import { createRouter, createWebHistory } from 'vue-router'
import { useWeb3Store } from '@/stores/web3'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      title: 'CuttleFusion - NFT Trading Card Game'
    }
  },
  {
    path: '/game',
    name: 'game',
    component: () => import('@/views/GameView.vue'),
    meta: {
      title: 'Game - CuttleFusion',
      requiresAuth: true
    }
  },
  {
    path: '/collection',
    name: 'collection',
    component: () => import('@/views/CollectionView.vue'),
    meta: {
      title: 'My Collection - CuttleFusion',
      requiresAuth: true
    }
  },
  {
    path: '/mint',
    name: 'mint',
    component: () => import('@/views/MintView.vue'),
    meta: {
      title: 'Mint - CuttleFusion',
      requiresAuth: true
    }
  },
  {
    path: '/marketplace',
    name: 'marketplace',
    component: () => import('@/views/MarketplaceView.vue'),
    meta: {
      title: 'Marketplace - CuttleFusion'
    }
  },
  {
    path: '/leaderboard',
    name: 'leaderboard',
    component: () => import('@/views/LeaderboardView.vue'),
    meta: {
      title: 'Leaderboard - CuttleFusion'
    }
  },
  {
    path: '/profile/:address?',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: {
      title: 'Profile - CuttleFusion'
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminView.vue'),
    meta: {
      title: 'Admin - CuttleFusion',
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue'),
    meta: {
      title: 'About - CuttleFusion'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: {
      title: 'Page Not Found - CuttleFusion'
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Global navigation guards
router.beforeEach(async (to, from, next) => {
  const web3Store = useWeb3Store()
  
  // Set page title
  if (to.meta.title) {
    document.title = to.meta.title as string
  }
  
  // Check authentication requirements
  if (to.meta.requiresAuth && !web3Store.isConnected) {
    web3Store.showConnectionModal = true
    next(false) // Stay on current page
    return
  }
  
  // Check admin requirements
  if (to.meta.requiresAdmin && !web3Store.isAdmin) {
    next({ name: 'home' })
    return
  }
  
  next()
})

export default router